import { HamburgerButtonComponenta } from "./hamburgerMenuList/hamburgerButton";
import { SearchButtonComponenta } from "./searchInput/openSearchButton";
import { MenuListComponenta, HamburgerMenuItems } from "./hamburgerMenuList/menuList"
import { CalcalistSearchComponenta } from "./searchInput/searchArea";

require('././hamburgerMenuList/ctech_calcalist_site_menu.less')
require('./searchInput/ctech_calcalist_site_search_area.less')
interface HamburgerProps {
    menuItems: HamburgerMenuItems[]
    menuGroup1: HamburgerMenuItems[]
    menuGroup2: HamburgerMenuItems[]
    menuGroup3: HamburgerMenuItems[]
    menuGroup4: HamburgerMenuItems[]
    menuGroup5: HamburgerMenuItems[]
    width: number
    domain:string
    hamburgerNewDesign: boolean
}

interface HamburgerState {
    isOpenedHam: boolean
    isOpenedSearch: boolean
}
export class LeftSideMenuComponenta extends React.Component<HamburgerProps, HamburgerState> {
    public static siteScriptName = "LeftSideMenuComponenta"
    constructor(props) {
        super(props)
        this.state = {
            isOpenedHam: false,
            isOpenedSearch: false
        }
    }

    private onToggleHam = () => {
        this.setState({ isOpenedHam: !this.state.isOpenedHam, isOpenedSearch: false })
    }
    private onToggleSearch = () => {
        this.setState({ isOpenedSearch: !this.state.isOpenedSearch, isOpenedHam: false })
    }
    render() {
        const { hamburgerNewDesign, menuItems, menuGroup1, menuGroup2, menuGroup3, menuGroup4, menuGroup5, width, domain } = this.props
        return (

            <div className="LeftSideMenu no-print">
                <SearchButtonComponenta onToggleSearch={this.onToggleSearch} isOpened={this.state.isOpenedSearch} />
                <HamburgerButtonComponenta onToggleMenu={this.onToggleHam} isOpened={this.state.isOpenedHam} />
                <MenuListComponenta hamburgerNewDesign={hamburgerNewDesign} menuItems={menuItems} menuGroup1={menuGroup1} menuGroup2={menuGroup2} menuGroup3={menuGroup3} menuGroup4={menuGroup4} menuGroup5={menuGroup5} width={width} isOpenedHam={this.state.isOpenedHam} />
                {this.state.isOpenedSearch && <CalcalistSearchComponenta width={width} domain={domain} />}
            </div>
        )


    }
}